import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, OnDestroy, Optional } from '@angular/core';
import { FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { ModuleNameService } from 'src/app/services/module-name.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-crm-business-edit',
  templateUrl: './crm-business-edit.component.html',
  styleUrls: ['./crm-business-edit.component.scss']
})
export class CrmBusinessEditComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';


  firstFormGroup: UntypedFormGroup;
  text: string;

  editIndex: number | null = null;

  constructor(@Optional() private dialogRef: MatDialogRef<CrmBusinessEditComponent>,
    private moduleNameService: ModuleNameService,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }


  ngOnInit() {

    this.getModuleList();
    this.initForm();
    this.text = "Save";

  }

  initForm() {
    this.firstFormGroup = this._formBuilder.group({
      modules: this._formBuilder.array([])
    });
  }

  // Create one module FormGroup
  createModuleGroup(): FormGroup {
    return this._formBuilder.group({
      id: [''],
      moduleName: [''],
      displayName: [''],
      description: [''],
      moduleIcons: [''],
      router: [''],
      operationType: [''],
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  modules: any;

  textsysn:string;

  enableSync: boolean = false

  getModuleList() {

    this.moduleNameService.getAllModuleNameDropDown().subscribe(
      res => {
        this.modules = res;

        console.log(this.modules , "modules");
        this.firstFormGroup.setControl('modules', this.patchModules(this.modules));

        if(this.modules == ''){
          this.enableSync = true;
          this.textsysn="Sync";
        }

        console.log("module", this.modules);


      },
      error => {
      })
  }



  saveCustomNames(updatedValues: any) {

  const index = this.modules.findIndex(m => m.id === updatedValues.id);
  if (index > -1) {
    this.modules[index].moduleName = updatedValues.moduleName;
    this.modules[index].displayName = updatedValues.displayName;
  }

   this.editIndex = null;
  }






  close(){
      this.dialogRef.close({ event: 'add', })
  }

  saveModulesName() {



    if (this.text == 'Save' && this.firstFormGroup.valid) {

      this.text = "Processing"

      this.moduleNameService.addOrEditModuleName(this.firstFormGroup.value.modules).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.close();
          }
          else {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { this.text = "Save"; });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  syncModule(){ 
    if (this.textsysn == 'Sync') {
      this.textsysn = "Processing"
      this.moduleNameService.syncData().subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.textsysn = "Sync";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.getModuleList();
            this.enableSync = false;
          }
          else {
            this.textsysn = "Sync";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { this.textsysn = "Sync" });
    }
    
  }

  patchModules(modules: any[]) {
    const formArray = new UntypedFormArray([]);
  
    modules.forEach(module => {
      formArray.push(this.createModuleFormGroup(module));
    });

    return formArray;
  }

  createModuleFormGroup(module?: any): FormGroup {
  return this._formBuilder.group({
    id: [module?.id || ''],
    moduleName: [module?.moduleName || ''],
    displayName: [module?.displayName || ''],
    description: [module?.description || ''],
    moduleIcons: [module?.moduleIcons || ''],
    router: [module?.router || ''],
    operationType: [module?.operationType || ''],
  });
}
  
get modulesFormArray(): FormArray {
  return this.firstFormGroup.get('modules') as FormArray;
}


enableEditNew(i: number): void {
  this.editIndex = i;

  // Optionally patch values into a temp form (if using one formGroup for editing)
  const module = this.modulesFormArray.at(i).value;

  // If you want to patch into the top-level firstFormGroup (like your earlier HTML)
  this.firstFormGroup.patchValue({
    moduleName: module.moduleName,
    displayName: module.displayName,
    description: module.description,
    moduleIcons: module.moduleIcons,
    router: module.router,
    operationType: module.operationType
  });
}



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
